import { useRef, useState } from "react";
import "../../../../css/RecruitmentScreen/Sections.css"; // Use your own styling
import { uploadAdditionalFiles } from "../../../../backend/Recruitment/DragandDraop"; // The backend function from previous code
import FileUpload from "../../../DesignSystem/Upload/FileUpload";
import UploadedFileList from "../../../DesignSystem/Upload/UploadedFileList";
import PrimaryButton from "../../../DesignSystem/Buttons/PrimaryButton";

const DragAndDrop = () => {
  const [files, setFiles] = useState([]);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const [uploadStatus, setUploadStatus] = useState(null);
  const fileInputIdRef = useRef(`additionalFilesInput_${Date.now()}`);

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(
      event?.target?.files || event?.dataTransfer?.files || [],
    );
    if (selectedFiles.length === 0) return;
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
    setFileInputKey(Date.now()); // Allow selecting the same file again if needed
  };

  const handleRemoveFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleUpload = async () => {
    if (files.length === 0) {
      alert("Please select or drop files before uploading.");
      return;
    }

    setUploadStatus("Uploading...");
    try {
      await uploadAdditionalFiles(files);
      setUploadStatus("Upload successful!");

      setFiles([]);
      setUploadStatus("");
    } catch (error) {
      // console.error("Error uploading files:", error);
      setUploadStatus("Error uploading files. Please try again.");
    }
  };

  return (
    <div className="drag-drop-container">
      <FileUpload
        description="Drag & drop files here or"
        browseText="Browse"
        onDrop={handleFileChange}
        onBrowse={() => document.getElementById(fileInputIdRef.current).click()}
      />
      <input
        type="file"
        multiple
        onChange={handleFileChange}
        style={{ display: "none" }}
        id={fileInputIdRef.current}
        key={fileInputKey}
      />

      {files.length > 0 && (
        <UploadedFileList
          files={files}
          onRemove={(_, index) => handleRemoveFile(index)}
        />
      )}

      {uploadStatus && <div className="Content-Small">{uploadStatus}</div>}

      <PrimaryButton onClick={handleUpload} disabled={files.length === 0}>
        Upload
      </PrimaryButton>
    </div>
  );
};

export default DragAndDrop;
